import { extract_features, Factory } from "sml-recommender-sdk";
import { database } from "./firebase";
import SmartCache from "./indexeddb";
import createDoc from "./utility/create_doc";
import syncImoveis from "./utility/sync_imoveis";
import { DateFromUnsafe } from "./utility/util_functions";

/**
 * Arquivo de worker usado para fazer processamento paralelo, dificilmente alguem vai precisar usar isso, mas caso precise está ai
 */
const ctx: Worker = self as any;

type MessageResponseType = {
    fn: string,
    from: number,
    output: any
}

const RecommenderFactory = new Factory({ imoveis: [], options: { weights_calc_type: 'alt' } })

const messageRespond: (messageResponse:MessageResponseType) => void = postMessage as any;

// Respond to message from parent thread
ctx.addEventListener("message", async (event) => {
    const { fn, input, config, from } = event.data;
    if (!fn) throw new Error('Nenhuma parametro [fn] foi passado para a mensagem!')
    
    const { empresa_id, user_id, imovel_id, cliente_id, visitante_id, sab, categoria, only_from_corretor_e_proprietarios } = (input || {});

    // Essa verificação só é necessária na sicronização
    if (fn.startsWith('sync') && !empresa_id) {
        return messageRespond({
            fn,
            from,
            output: new Error(`Nenhuma empresa foi adicionada como input a chamada da função: ${fn}`)
        })
    }

    switch (fn) {
        case 'recommender-para-visitante':
            try {
                const visitante = await SmartCache.visitas.getById(visitante_id);
                const recommender_res = RecommenderFactory.imoveis_recomendados_para_visitante(visitante, { ...input.options, from_visitante: visitante });
                
                messageRespond({
                    fn,
                    from,
                    output: {
                        recommender_res,
                        imoveis: await SmartCache.imoveis.getMultipleById(recommender_res.ids)
                    }
                })
            } catch (error) {
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            break;
        case 'recommender-by-imovel-id':
            try {
                const recommender_res = RecommenderFactory.imoveis_semelhantes_por_id(imovel_id, input.options)
                
                messageRespond({
                    fn,
                    from,
                    output: {
                        recommender_res,
                        imoveis: await SmartCache.imoveis.getMultipleById((recommender_res.ids).filter(id => id !== imovel_id))
                    }
                })
            } catch (error) {
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            break;
        case 'recommender-update':
            try {
                if (false) {
                    const all_imoveis = await SmartCache.imoveis.getAll()
                    if (all_imoveis.length < 1000) {
                        RecommenderFactory.recalc_imoveis(all_imoveis.map(extract_features))
                    }
                }
                messageRespond({
                    fn,
                    from,
                    output: true
                })
            } catch (error) {
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            break;
        case 'sync-visitas':
            let counter_:true|number = 0;
            let one_visita = await SmartCache.visitas.getOne();
            try {
                try {
                    if (!one_visita) {
                        counter_ = await RecursiveVisitas(null, empresa_id, sab);
                    } else {
                        let ultimo_visitante_editado = await SmartCache.visitas.getMaxByIndex('time_ultima_visita');
                        if (ultimo_visitante_editado) {
                            
                            let visitantes_atualizados = await database.collection(`info_empresas/${empresa_id}/visitantes`)
                            .orderBy('time_ultima_visita','desc')
                            .endAt(ultimo_visitante_editado.time_ultima_visita).get();
                            counter_+=visitantes_atualizados.size
                            const visitantes_atualizados_map = visitantes_atualizados.docs.map(doc => ({...doc.data(), db_id: doc.id}))

                            if (sab) {
                                Atomics.add(new Uint32Array(sab), 1, visitantes_atualizados_map.length)
                            }

                            for await (const visitante of visitantes_atualizados_map) {
                                let visitante_cache = await SmartCache.visitas.getById(visitante.db_id);
                                if (visitante_cache) {
                                    await SmartCache.visitas.updateById(visitante.db_id, visitante);
                                } else {
                                    await SmartCache.visitas.add(visitante);
                                }
                                
                                if (sab) {
                                    Atomics.add(new Uint32Array(sab), 0, 1)
                                }
                            }
                        }
                    }
                } catch (error) {
                    messageRespond({
                        fn,
                        from,
                        output: error
                    })
                }
            } catch (error) {
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            messageRespond({
                fn,
                from,
                output: {counter_, one_visita}
            })
            break;
        case 'sync-imoveis':
            let one_imovel = await SmartCache.imoveis.getOne();
            let counter: true|number = 0;
            try {
                if (!one_imovel) {
                    counter = await RecursiveImoveis(null, empresa_id, sab, categoria);
                } else {
                    counter = await syncImoveis(empresa_id, sab, categoria)
                }
                messageRespond({
                    fn,
                    from,
                    output: { counter, one_imovel }
                })
            } catch (error) {
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            break;
        case 'sync-clientes':
            try {
                // Verifica se já existe algum cliente na IDB
                const one_cliente = await SmartCache.clientes.getOne();
                let counter__:true|number = 0
                if (!one_cliente) {
                    // Caso não tenha nenhum cliente, fazer um get recursivo para popular o IDB
                    counter__ = await RecursiveClientes(null, empresa_id, sab, only_from_corretor_e_proprietarios);
                } else {
                    const ultimo_cliente_editado = await SmartCache.clientes.getByLastDate('edited_at');
                    const primeiro_cliente_editado = await SmartCache.clientes.getByFirstDate('edited_at');
                    console.log({ultimo_cliente_editado,
                        primeiro_cliente_editado})
                    if (ultimo_cliente_editado) {
            
                        let clientes_atualizados = database.collection(`empresas/${empresa_id}/clientes`)
                        if (only_from_corretor_e_proprietarios) {
                            // @ts-ignore
                            clientes_atualizados = clientes_atualizados.where('corretor_responsavel', '==', only_from_corretor_e_proprietarios)
                            // @ts-ignore
                            clientes_atualizados = clientes_atualizados.orderBy('corretor_responsavel', 'asc')
                        }
                        const clientes_atualizados_get = await clientes_atualizados.orderBy('edited_at','asc')
                        // Um bug ocorreu um dia e fez alguns edited_at virarem string
                        // o ideal seria corregir no banco já que isso nunca mais vai acontecer (eu espero)
                        .startAt(DateFromUnsafe(ultimo_cliente_editado.edited_at))
                        .get();
                        counter__+=clientes_atualizados_get.size
                        
                        const clientes_atualizados_data = clientes_atualizados_get.docs.map(createDoc)
                        const clientes = clientes_atualizados_data.filter(cliente => cliente.edited_at)
                        const clientes_ids = clientes.map(cliente => cliente.db_id)
                        const clientes_no_cache = await SmartCache.clientes.getMultipleByIdMapReturn(clientes_ids)
                        const clientes_pra_att:any[] = []

                        if (sab) {
                            Atomics.add(new Uint32Array(sab), 1, clientes_atualizados_get.size)
                        }
                        
                        for (const cliente of clientes) {
                            const cliente_cache = clientes_no_cache.get(cliente.db_id)
                            // Caso não esteja no cache, ou seja, imovel novo 
                            if (!cliente_cache && cliente) {
                                clientes_pra_att.push(cliente)
                                continue;
                            }
                            
                            if (!cliente_cache.edited_at || !cliente.edited_at) continue;
                            if (DateFromUnsafe(cliente_cache.edited_at).getTime() !== DateFromUnsafe(cliente.edited_at).getTime()) {
                                clientes_pra_att.push(cliente)
                            }
                        }
                        
                        console.log('Clientes ultimo_cliente_editado diff', clientes_pra_att)
                        if (clientes_pra_att.length) {
                            await SmartCache.clientes.addMultiple(clientes_pra_att)
                        }
                    }
                    // @todo: otimização do combo de addMultiple+getMultipleByIdMapReturn , não fiz agora por que a maioria das alteração em massa alteram o edited_at pra uma data mais recente
                    if (primeiro_cliente_editado) {
                        let clientes_atualizados = database.collection(`empresas/${empresa_id}/clientes`)
                        if (only_from_corretor_e_proprietarios) {
                            // @ts-ignore
                            clientes_atualizados = clientes_atualizados.where('corretor_responsavel', '==', only_from_corretor_e_proprietarios)
                            // @ts-ignore
                            clientes_atualizados = clientes_atualizados.orderBy('corretor_responsavel', 'asc')
                        }
                        // Um bug ocorreu um dia e fez alguns edited_at virarem string
                        // o ideal seria corregir no banco já que isso nunca mais vai acontecer (eu espero)
                        // e alterar isso para ficar mais legivel
                        const clientes_atualizados_get = await clientes_atualizados
                        .orderBy('edited_at','desc')
                        .startAt(DateFromUnsafe(primeiro_cliente_editado.edited_at))
                        .get();

                        counter__+=clientes_atualizados_get.size
                        if (sab) {
                            Atomics.add(new Uint32Array(sab), 1, clientes_atualizados_get.size)
                        }
                        
                        for await (const cliente of clientes_atualizados_get.docs.map(createDoc)) {
                            if (!cliente.edited_at) continue;
                            let cliente_cache = await SmartCache.clientes.getById(cliente.db_id);
                            if (cliente_cache) {
                                await SmartCache.clientes.updateById(cliente.db_id, cliente);
                            } else {
                                await SmartCache.clientes.add(cliente);
                            }
                            if (sab) {
                                Atomics.add(new Uint32Array(sab), 0, 1)
                            }
                        }
                    }
                }

                if (only_from_corretor_e_proprietarios) {
                    const clientes_ref = await database.collection(`empresas/${empresa_id}/clientes`)
                    .where('proprietario', '==', true)
                    .get()
                    
                    if (sab) {
                        // Talvez isso precise ser revisitado, ja que o contador deve exeder o numero de clientes totais
                        // Atomics.add(new Uint32Array(sab), 1, clientes_ref.size)
                    }

                    await SmartCache.clientes.addMultiple(clientes_ref.docs.map(createDoc), null, () => {
                        if (sab) {
                            // Atomics.add(new Uint32Array(sab), 0, 1)
                        }
                    })
                }
                messageRespond({
                    fn,
                    from,
                    output: { one_cliente, counter__ }
                })
            } catch (error) {
                console.log(error)
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            break;
        case 'sync-empreendimentos':
            try {
                // Verifica se já existe algum empreendimento na IDB
                
                const one_empreendimento = await SmartCache.empreendimentos.getOne();
        
                // Caso não tenha vamos pegar todos os empreendimentos e adicionar ao IDB
                if (!one_empreendimento) {
                    // Get todos os empreendimentos
                    const empreendimentos_ref = await database.collection(`empresas/${empresa_id}/empreendimentos`).get()
                    
                    if (sab) {
                        Atomics.add(new Uint32Array(sab), 1, empreendimentos_ref.size)
                    }

                    // Adiciona a IDB
                    await SmartCache.empreendimentos.addMultiple(empreendimentos_ref.docs.map(createDoc), null, () => {
                        if (sab) {
                            Atomics.add(new Uint32Array(sab), 0, 1)
                        }
                    })

                } else {
                    // Verifica o último empreendimento editado, com base nisso nós vamos pegar apenas os empreendimentos editados após esse
                    const ultimo_empreendimento_editado = await SmartCache.empreendimentos.getByLastDate('edited_at');
                    
                    if (ultimo_empreendimento_editado) {
            
                        const empreendimentos_atualizados = await database.collection(`empresas/${empresa_id}/empreendimentos`)
                        .orderBy('edited_at','asc')
                        .startAt(ultimo_empreendimento_editado.edited_at)
                        .get();

                        if (sab) {
                            Atomics.add(new Uint32Array(sab), 1, empreendimentos_atualizados.size)
                        }
                        
                        for await (const empreendimento of empreendimentos_atualizados.docs.map(createDoc)) {
                            const empreendimento_cache = await SmartCache.empreendimentos.getById(empreendimento.db_id);
                            if (empreendimento_cache) {
                                await SmartCache.empreendimentos.updateById(empreendimento.db_id, empreendimento);
                            } else {
                                await SmartCache.empreendimentos.add(empreendimento);
                            }
                            if (sab) {
                                Atomics.add(new Uint32Array(sab), 0, 1)
                            }
                        }
                    }
                }
                messageRespond({
                    fn,
                    from,
                    output: true
                })
            } catch (error) {
                messageRespond({
                    fn,
                    from,
                    output: error
                })
            }
            break;
        default:
            messageRespond({
                fn: 'undef-fn',
                from,
                output: `Nenhuma função foi compativel com sua chamada. Sua fn: ${fn}`
            })
            break;
    }
});

// [?/?] Percorre recursivamente 2 iterações de clientes do banco, para não fazer uma chamada muito grande pro banco
// já que isso pode quebrar em conexões mais fracas com a internet
// [02/22] aparentemente tem clientes com tanto mais tanto cliente que 2 iterações não vai ser suficiente, @todo: transformar isso em recursão real
async function RecursiveClientes(startAfter:any, empresa:string, sab: SharedArrayBuffer, only_from_corretor_e_proprietarios?:string):Promise<true|number> {
    const limit = (empresa === 'gCoy0kEcTnRBVlpVSvNf'|| empresa === 'AjiGvSzaiBhKko3N2GxN') ? 4000 : 4000
    try {
        if (!empresa) return true
        let clientes_ref = database.collection(`empresas/${empresa}/clientes`)
        if (only_from_corretor_e_proprietarios) {
            // @ts-ignore
            clientes_ref = clientes_ref.where('corretor_responsavel', '==', only_from_corretor_e_proprietarios)
            // @ts-ignore
            clientes_ref = clientes_ref.orderBy('corretor_responsavel', 'asc')
        }
        // @ts-ignore
        clientes_ref = clientes_ref.orderBy('edited_at','desc')

        if (startAfter) {
            // @ts-ignore Tipagem do firebase deu a louca
            clientes_ref = clientes_ref.startAfter(startAfter).limit(limit);
        } else {
            // @ts-ignore
            clientes_ref = clientes_ref.limit(limit);
        }

        const clientes_get_ref = await clientes_ref.get();
        
        if (sab) {
            Atomics.add(new Uint32Array(sab), 1, clientes_get_ref.size)
        }

        let promise_add;
        if (sab) { 
            promise_add = SmartCache.clientes.addMultiple(clientes_get_ref.docs.map(createDoc), undefined, sab ? () => {
                if (sab) {
                    Atomics.add(new Uint32Array(sab), 0, 1)
                }
            } : undefined)
        } else {
            promise_add = SmartCache.clientes.addMultiple(clientes_get_ref.docs.map(createDoc))
        }
        await promise_add

        if (clientes_get_ref.size === limit) return RecursiveClientes(clientes_get_ref.docs[clientes_get_ref.docs.length - 1], empresa, sab, only_from_corretor_e_proprietarios);

        return clientes_get_ref.size;
    } catch (error) {
        console.log(error, 'IN')
    }
    return true
}

/**
 * Recursivamente pega os imóveis do banco e os adiciona no indexeddb
 * @param {*} startAfter 
 * @param {string} empresa 
 */
async function RecursiveImoveis(startAfter:any, empresa:string, sab: SharedArrayBuffer, categoria:'locacao'|'venda'):Promise<true|number> {
    const limit = (empresa === 'gCoy0kEcTnRBVlpVSvNf'|| empresa === '2GObPcOGelkJsFaqYs6B' || empresa === 'AjiGvSzaiBhKko3N2GxN') ? 2000 : 3000
    if (!empresa) return true
    let imoveis_ref = database.collection(`empresas/${empresa}/imoveis`)
    // if (categoria) {
    //     if (categoria === 'venda') {
    //         // @ts-ignore
    //         imoveis_ref = imoveis_ref.where('venda', '==', true)
    //         // @ts-ignore
    //         imoveis_ref = imoveis_ref.orderBy('venda', 'asc')
    //     } else if (categoria === 'locacao') {
    //         // @ts-ignore
    //         imoveis_ref = imoveis_ref.where('venda', '!=', true)
    //         // @ts-ignore
    //         imoveis_ref = imoveis_ref.orderBy('venda', 'asc')
    //     }
    // }
    if (startAfter) {
        // @ts-ignore
        imoveis_ref = imoveis_ref.startAfter(startAfter).limit(limit)
    } else {
        // @ts-ignore
        imoveis_ref = imoveis_ref.limit(limit);
    }
    
    let imoveis_get_ref = await imoveis_ref.get();
    
    if (sab) {
        Atomics.add(new Uint32Array(sab), 1, imoveis_get_ref.size)
    }

    await SmartCache.imoveis.addMultiple(imoveis_get_ref.docs.map(doc => ({...doc.data(), db_id: doc.id})), undefined, sab ? () => {
        if (sab) {
            Atomics.add(new Uint32Array(sab), 0, 1)
        }
    } : undefined)

    if (imoveis_get_ref.size === limit) return RecursiveImoveis(imoveis_get_ref.docs[imoveis_get_ref.docs.length - 1], empresa, sab, categoria);

    return imoveis_get_ref.size
}

/**
 * Recursivamente pega as visitas do banco e os adiciona no indexeddb
 * @param {*} startAfter 
 * @param {string} empresa 
 */
async function RecursiveVisitas(startAfter:any, empresa:string, sab: SharedArrayBuffer):Promise<true|number> {
    if (!empresa) return true
    let visitas_ref = database.collection(`info_empresas/${empresa}/visitantes`).orderBy('time_ultima_visita','desc')
    if (startAfter) {
        visitas_ref = visitas_ref.startAfter(startAfter)
    } else {
        visitas_ref = visitas_ref.limit(4000);
    }

    let visitas_get_ref = await visitas_ref.get();

    if (sab) {
        Atomics.add(new Uint32Array(sab), 1, visitas_get_ref.size)
    }
    
    const visitas_data = visitas_get_ref.docs.map(doc => ({...doc.data(), db_id: doc.id}));
    await SmartCache.visitas.addMultiple(visitas_data, undefined, sab ? () => {
        if (sab) {
            Atomics.add(new Uint32Array(sab), 0, 1)
        }
    } : undefined);

    if (visitas_get_ref.size === 4000) return RecursiveVisitas(visitas_get_ref.docs[3999], empresa, sab);
    return visitas_get_ref.size
}
export default ctx